export const LOGGED_IN = 'LOGGED_IN';
